
import { Component, mixins } from 'nuxt-property-decorator'
import hotNfts from '@/queries/rmrk/subsquid/hotNfts.graphql'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import { RowHot, SubsquidHotNft } from './types'
import { NeoSkeleton, NeoTable, NeoTableColumn } from '@kodadot1/brick'

import PrefixMixin from '~/utils/mixins/prefixMixin'
import ChainMixin from '@/utils/mixins/chainMixin'
import formatBalance from '@/utils/format/balance'
import { getVolume } from '@/utils/math'
import { lastweekDate } from '@/components/series/utils'

const components = {
  NeoSkeleton,
  NeoTable,
  NeoTableColumn,
}

@Component({
  components,
})
export default class HotTable extends mixins(PrefixMixin, ChainMixin) {
  protected data: RowHot[] = []
  private toKSM(amount) {
    return formatBalance(amount, this.decimals, '')
  }

  async fetch() {
    const data = await this.fetchHotNfts()
    const collectionMap = groupBy(data, 'nft.collection.id')
    const sortOrder = [...new Set(data.map((e) => e.nft.collection.id))]
    const result: RowHot[] = sortOrder.map((colId, idx) => {
      const collection = collectionMap[colId][0].nft.collection
      const nfts = sortBy(collectionMap[colId], 'timestamp').reverse()
      const totalVolume = this.toKSM(getVolume(nfts))
      const buys = nfts.length
      const latestSale = nfts[0]
      const medianIdx = Math.floor(buys / 2)
      return {
        id: idx + 1,
        collectionId: colId,
        name: collection.name,
        totalVolume,
        buys,
        latestSoldSize: this.toKSM(latestSale.meta),
        latestSoldTime: formatDistanceToNow(new Date(latestSale.timestamp)),
        medianDate: formatDistanceToNow(new Date(nfts[medianIdx].timestamp)),
        nfts,
      }
    })
    this.data = result
  }

  public async fetchHotNfts(): Promise<[SubsquidHotNft]> {
    const {
      data: { result },
    } = await this.$apollo.query({
      query: hotNfts,
      client: this.client,
      variables: {
        gte: lastweekDate,
      },
    })
    return result
  }
}
